import Column from 'components/atoms/column'
import { State, StateController } from 'components/atoms/state-controller'
import Text from 'components/atoms/text'
import Checkbox from 'components/molecules/checkbox'
import React from 'react'
import { MarketProductCategoryType } from 'types/market-product-category-type'

export interface CheckboxProps {
  value?: MarketProductCategoryType[]
  options?: MarketProductCategoryType[]
  pending?: boolean
  onChange?: (options: MarketProductCategoryType[]) => void
}

const CheckboxList: React.FC<CheckboxProps> = ({
  value = [],
  options = [],
  pending,
  onChange,
}) => {
  const currentState = pending
    ? 'loading'
    : options.length
    ? 'complete'
    : 'empty'

  const handleCheckboxClick = (
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const addCategory = (
      categories: MarketProductCategoryType[],
      category: MarketProductCategoryType
    ) => [...categories, category]
    const removeCategory = (
      categories: MarketProductCategoryType[],
      category: MarketProductCategoryType
    ) => categories.filter((current) => current._id !== category._id)

    const categoryId = event.target.value
    const category = options.find((category) => category._id === categoryId)
    const newValue = checked
      ? addCategory(value, category)
      : removeCategory(value, category)
    onChange?.(newValue)
  }
  return (
    <fieldset>
      <legend className="py-2 text-base font-bold text-black lg:text-white">
        Escolha por categorias
      </legend>

      <StateController currentState={currentState}>
        <State id="loading">
          <Text>Carregando...</Text>
        </State>
        <State id="empty">
          <Text>Nenhum filtro encontrado</Text>
        </State>
        <State id="complete">
          <Column className="space-y-sm">
            {options.map((category) => {
              const checked = value.some((item) => item._id === category._id)
              return (
                <Checkbox
                  className="text-sm font-normal text-black lg:text-white"
                  key={category._id}
                  label={category.name}
                  onChange={handleCheckboxClick}
                  color="default"
                  value={category._id}
                  checked={checked}
                />
              )
            })}
          </Column>
        </State>
      </StateController>
    </fieldset>
  )
}

export default CheckboxList
